module.exports = __webpack_public_path__ + "static/media/equipe-tindog4.25f2c7a9.png";